require('./brokerInternalTransferFunds.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const moment = require('moment');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');

// @components
const BrokerInternalTransferFundsPreStep = require('components/broker/brokerInternalTransferFunds/brokerInternalTransferFundsPreStep/brokerInternalTransferFundsPreStep');
const BrokerInternalTransferFundsStep1 = require('components/broker/brokerInternalTransferFunds/brokerInternalTransferFundsStep1/brokerInternalTransferFundsStep1');
const BrokerInternalTransferFundsStep2 = require('components/broker/brokerInternalTransferFunds/brokerInternalTransferFundsStep2/brokerInternalTransferFundsStep2');
const { BrokerInternalTransferFundContributionStep } = require('./brokerInternalTransferFundContributionStep/brokerInternalTransferFundContributionStep');
const BrokerInternalTransferFundsDetails = require('components/broker/brokerInternalTransferFunds/brokerInternalTransferFundsDetails/brokerInternalTransferFundsDetails');
const BrokerInternalTransferFundsSuccess = require('components/broker/brokerInternalTransferFunds/brokerInternalTransferFundsSuccess/brokerInternalTransferFundsSuccess');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { BrokerMiFIDBehavior } = require('mifid/components/brokerMiFIDBehavior/brokerMiFIDBehavior');

//@contact-center
const ContactCenterInternalTransferFundStep2 = require('components/contactCenter/hireInvestmentFunds/internalTransferFund/internalTransferFundStep2/internalTransferFundStep2');

// @helpers
const { formatText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');

// @constantss
const {
    FIRST_STEP,
    BROKER_YELLOW_FUND,
    MYPROFILE_BROKER_URL,
    BROKER_GREEN_FUND,
    BROKER_RED_FUND,
    BROKER_MIFID_FUND_RED,
    BROKER_MIFID_FUND_YELLOW,
    BROKER_MIFID_FUND_GREEN,
    BROKER_CONVENIENCE_MIFID_TEST_INTERNAL_TRANSFER_FUND,
    BROKER_MIFID_VERSION_2,
    BROKER_INTERNAL_TRANSFER_NEW_FUND,
    MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND,
    BROKER_FUND_MIFID_ID
} = require('constants/index');
const { catalogue, analyticsId } = require('./analytics/brokerInternalTransferFunds.tracking');

class BrokerInternalTransferFunds extends React.Component {

    constructor(props) {
        super(props);
        this.onCancel = this.onCancel.bind(this);
        this.onFinish = this.onFinish.bind(this);
        this.buildMifid = this.buildMifid.bind(this);
        this.getFundMiFIDv1Id = this.getFundMiFIDv1Id.bind(this);
        this.getFundType = this.getFundType.bind(this);
        this.buildMiFIDBreadcrumb = this.buildMiFIDBreadcrumb.bind(this);
        this.onClickNextSelectFundPage = this.onClickNextSelectFundPage.bind(this);
    }

    componentDidMount(){
        const{ immFunds, setEmptyState, history } = this.props;
        if (immFunds.size === 0) {
            setEmptyState(history);
        }
    }

    onCancel() {
        this.props.onCancel();
    }

    onFinish() {
        this.props.onFinish();
    }

    onClickNextSelectFundPage() {
        const{ setOriginContributionFundStep, immBrokerInternalTransferFunds } = this.props;
        const immSteps = immBrokerInternalTransferFunds.get('steps');
        const originHasContribution = immSteps.getIn([FIRST_STEP, 'originHasContribution']);
        const destinationHasContribution = immSteps.getIn([FIRST_STEP, 'destinationHasContribution']);
        const onlyOriginContribution = originHasContribution && !destinationHasContribution;
        const originContributionDetails = immSteps.getIn([FIRST_STEP, 'originContributionDetails']);
        const isTotalTransfer = immSteps.getIn([FIRST_STEP, 'type']) === 'total';

        if (onlyOriginContribution && isTotalTransfer && originContributionDetails) {
            setOriginContributionFundStep(originContributionDetails);
        }
        this.props.onSelectFundsStepNextClick();
    }

    getFundMiFIDv1Id() {
        switch (this.getFundType()) {
            case BROKER_RED_FUND:
                return BROKER_MIFID_FUND_RED;
            case BROKER_YELLOW_FUND:
                return BROKER_MIFID_FUND_YELLOW;
            case BROKER_GREEN_FUND:
                return BROKER_MIFID_FUND_GREEN;
            default:
                return BROKER_FUND_MIFID_ID;
        }
    }

    getFundType() {
        const { immInvestmentFunds } = this.props;

        return immInvestmentFunds.getIn([
            'steps',
            FIRST_STEP,
            'investmentFunds',
            'customCategoryId3'
        ]);
    }

    buildMiFIDBreadcrumb() {
        return [
            {
                text: formatText('breadcrumb-brokerMyWallet'),
                url: MYPROFILE_BROKER_URL,
            },
            {
                text: formatText('broker-internalTransferFundMiFIDTitle'),
                url: undefined,
            }
        ];
    }


    buildMifid() {
        const { immBrokerInternalTransferFunds, immBrokerMyInvestments, immInvestmentFunds } = this.props;

        const immFunds = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']);
        const immInvestmentFund = immInvestmentFunds.get('investmentFunds');

        const originFundId = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFund']);
        const fundType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'fundType']);

        let destinationFundId, destinationFund;
        if (fundType === BROKER_INTERNAL_TRANSFER_NEW_FUND) {
            destinationFundId = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'selectedNewFund']);
            destinationFund = {
                name: immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'selectedNewFundName']),
                isin: immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'selectedNewFundISIN']),
            }
        } else {
            destinationFundId = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'destinationFund']);
            const immDestinationFund = immFunds.find(
                immFund => immFund.get('id') == destinationFundId
            );

            if (immDestinationFund) {
                // Get isin from investmentFunds reducer if isin comes null from pg-valores
                let destinationFundIsin = immDestinationFund.get('isin');
                if (!destinationFundIsin &&
                    immInvestmentFund.get('customInstitutionSecurityId') ===
                    immDestinationFund.get('customInstitutionSecurityId')
                ) {
                    destinationFundIsin = immInvestmentFund.get('isin');
                }

                destinationFund = {
                    isin: destinationFundIsin,
                    name: immDestinationFund.get('name'),
                };
            }
        }

        const selectedFundsAndContinueClicked =
            immBrokerInternalTransferFunds.get('stepSelectFundsLoading');

        if (destinationFund && selectedFundsAndContinueClicked) {
            const productName = destinationFund.name;
            const productUrl = undefined;
            const continuationUrl = MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND;
            const destinationFundMifidId = this.getFundMiFIDv1Id();
            const fundType = this.getFundType();
            const hideAlreadyPerformTestResult =
                fundType === BROKER_YELLOW_FUND || fundType === BROKER_GREEN_FUND;

            const mifidOptions = {
                operationType: BROKER_CONVENIENCE_MIFID_TEST_INTERNAL_TRANSFER_FUND,
                productType: BROKER_CONVENIENCE_MIFID_TEST_INTERNAL_TRANSFER_FUND,
                originFund: originFundId,
                destinationFund: destinationFundId,
                displayMifidDisclaimer: hideAlreadyPerformTestResult,
                hideAlreadyPerformTestResult,
                breadcrumb: this.buildMiFIDBreadcrumb()
            };

            return (
                <BrokerMiFIDBehavior
                    mifidVersion={BROKER_MIFID_VERSION_2}
                    productName={productName}
                    productUrl={productUrl}
                    continuationUrl={continuationUrl}
                    productIsinId={destinationFund.isin}
                    productMifidId={destinationFundMifidId}
                    mifidOptions={mifidOptions}
                />
            );
        }
    }

    buildContactCenterStep2(details) {
        const {
            immBrokerInternalTransferFunds,
            immBrokerMyInvestments,
            immInvestmentFunds,
            immProfileFields,
            immPreContractualMail,
            immFlagBasedFeatures,
            getPreMotor,
            getMorningStarScreener,
            legalYesNoOptionChange,
            resetLegalInformation,
            sendEmail,
            resetEmailState,
            refreshEmailAddress,
            immAccounts,
            immFunds
        } = this.props;
        return (
            <ContactCenterInternalTransferFundStep2
                immInternalTransferFund={immBrokerInternalTransferFunds}
                immBrokerMyInvestments={immBrokerMyInvestments}
                immInvestmentFunds={immInvestmentFunds}
                immProfileFields={immProfileFields}
                immPreContractualMail={immPreContractualMail}
                immFlagBasedFeatures={immFlagBasedFeatures}
                getPreMotor={getPreMotor}
                getMorningStarScreener={getMorningStarScreener}
                legalYesNoOptionChange={legalYesNoOptionChange}
                resetLegalInformation={resetLegalInformation}
                sendEmail={sendEmail}
                resetEmailState={resetEmailState}
                refreshEmailAddress={refreshEmailAddress}
                fundVersionNew={true}
                immAccounts={immAccounts}
                immFunds={immFunds}
            >
                {details}
            </ContactCenterInternalTransferFundStep2>
        );
    }


    buildSelectFundsStep() {
        const {
            setOriginFundChange,
            setDestinationFund,
            immDestinationFunds,
            immBrokerMyInvestments,
            immBrokerInternalTransferFunds,
            immFlagBasedFeatures,
            onCancel,
            inputSearchFundSelected,
            onChangeFundType,
            hideModalSelectFunds
        } = this.props;
        const immFunds = immBrokerMyInvestments
                            .getIn(['products','funds','stocks'])
                            .filter(immFund => immFund.get('totalValue') > 0);

        return (
            <BrokerInternalTransferFundsPreStep
                immDestinationFunds={immDestinationFunds}
                immBrokerInternalTransferFunds={immBrokerInternalTransferFunds}
                immFlagBasedFeatures={immFlagBasedFeatures}
                immBrokerMyInvestments={this.props.immBrokerMyInvestments}
                immFunds={immFunds}
                setOriginFundChange={setOriginFundChange}
                setDestinationFund={setDestinationFund}
                onNextClick={this.onClickNextSelectFundPage}
                onCancelClick={onCancel}
                selectedNewFund={immBrokerInternalTransferFunds.getIn(['steps', 0, 'selectedNewFund'])}
                inputSearchFundSelected={inputSearchFundSelected}
                onChangeFundType={onChangeFundType}
                hideModalSelectFunds={hideModalSelectFunds}
            />
        );
    }

    buildContributionStep = () => {
        const {
            isin,
            onStepChange,
            customMinimumPurchaseAmount,
            amount,
            amountErrorState,
            amountErrorMsg,
            setAmount,
            periodicityError,
            periodicityErrorMsg,
            periodicityValue,
            periodicityOptions,
            setPeriodicity,
            setValidityDate,
            selectedDate,
            minDate,
            setDatePickerError,
            skipContributionStep
        } = this.props;


        return (
          <WizardStep position="middle" cancelButton={true} nextButton={true} previousButton={true}>
            <BrokerInternalTransferFundContributionStep
              isin={isin}
              onStepChange={onStepChange}
              customMinimumPurchaseAmount={customMinimumPurchaseAmount}
              amount={amount}
              amountErrorState={amountErrorState}
              amountErrorMsg={amountErrorMsg}
              setAmount={setAmount}
              periodicityError={periodicityError}
              periodicityErrorMsg={periodicityErrorMsg}
              periodicityValue={periodicityValue}
              periodicityOptions={periodicityOptions}
              setPeriodicity={setPeriodicity}
              setValidityDate={setValidityDate}
              selectedDate={selectedDate}
              minDate={minDate}
              setDatePickerError={setDatePickerError}
              skipContributionStep={skipContributionStep}
            ></BrokerInternalTransferFundContributionStep>
          </WizardStep>
        );
    }

    buildWizard(details) {
        const {
            immBrokerInternalTransferFunds,
            validateStep,
            setVisibleStep,
            setWillCancel,
            setDestinationFund,
            getPreMotor,
            immFunds,
            immAccounts,
            getMorningStarScreener,
            immInvestmentFunds,
            onDisclaimerChecked,
            immBrokerMiFIDProducts,
            immDestinationFunds,
            onFetchBrokerMiFIDProduct,
            getInterveners,
            immFlagBasedFeatures,
            validateDestinationFundDocuments,
            validateEconomicReport,
            immSignaturePattern,
            setOriginContributionFundStep,
            immBrokerMyInvestments,
        } = this.props;
        const immSteps = immBrokerInternalTransferFunds.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immBrokerInternalTransferFunds.get('visibleStep');
        const wizardClass = 'broker-internal-transfer-funds__wizard';
        const immFinalButton = 'broker-hireInvestmentSubmit';
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.onFinish,
            cancel: this.onCancel
        };
        const immInvestment = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']);
        const destinationFundId = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'destinationFund']);
        const immDestinationFund = immInvestment.find(
            immFund => immFund.get('id') == destinationFundId
        );
        const productName = immDestinationFund?.get('name')
		const isin = immDestinationFund?.get('isin')

        const tealiumDataWithContribution = [
          catalogue[analyticsId.BROKER_INTERNAL_TRANSFER_FUNDS_STEP_1_VIEW]({ productName: isin, stepNumber: 1 }),
          catalogue[analyticsId.BROKER_INTERNAL_TRANSFER_FUNDS_STEP_1_VIEW]({ productName: isin, stepNumber: 2 }),
          catalogue[analyticsId.BROKER_INTERNAL_TRANSFER_FUNDS_STEP_2_VIEW]({ productName: isin, stepNumber: 3 }),
        ];
        const tealiumDataWithOutContribution = [
            catalogue[analyticsId.BROKER_INTERNAL_TRANSFER_FUNDS_STEP_1_VIEW]({ productName: isin, stepNumber: 1 }),
            catalogue[analyticsId.BROKER_INTERNAL_TRANSFER_FUNDS_STEP_2_VIEW]({ productName: isin, stepNumber: 2 }),
          ];
        const originHasContribution = immSteps.getIn([FIRST_STEP, 'originHasContribution']);
        const destinationHasContribution = immSteps.getIn([FIRST_STEP, 'destinationHasContribution']);
        const onlyOriginContribution = originHasContribution && !destinationHasContribution;
        const isTotalTransfer = immSteps.getIn([FIRST_STEP, 'type']) === 'total';
        const secondStepData = immSteps.get(1);
        const hasContributionStep = secondStepData.get('hasPreviousContributions');
        const contributionStep = this.buildContributionStep();

        const steps = [
            (
            <WizardStep
                position="first"
                cancelButton={true}
                nextButton={true}
            >
                <BrokerInternalTransferFundsStep1
                    onSetAmount={this.props.handleSetAmount}
                    setAproxAmountParticipations={this.props.setAproxAmountParticipations}
                    onChangeType={this.props.handleChangeType}
                    immBrokerMyInvestments={this.props.immBrokerMyInvestments}
                    immBrokerInternalTransferFunds={this.props.immBrokerInternalTransferFunds}
                    immDestinationFunds={immDestinationFunds}
                    handleOnOriginFundChange={this.props.setOriginFundChange}
                    handleSetDestinationFund={setDestinationFund}
                    immFunds={immFunds}
                    immAccounts={immAccounts}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immBrokerMiFIDProducts={immBrokerMiFIDProducts}
                    onChangePartialTransferType={this.props.onChangePartialTransferType}
                    onFetchBrokerMiFIDProduct={onFetchBrokerMiFIDProduct}
                    getMorningStarScreener={getMorningStarScreener}
                    immInvestmentFunds={immInvestmentFunds}
                />
            </WizardStep>
            ),
            (
            <WizardStep
                position="last"
                cancelButton={true}
                previousButton={true}
                finishButton={true}
                addLoadingBehaviour={true}
                immFinalButton={immFinalButton}
            >
                {
                    __CONTACT_CENTER__
                        ?  this.buildContactCenterStep2(details)
                        : (
                            <BrokerInternalTransferFundsStep2
                                immSignaturePattern={immSignaturePattern}
                                getInterveners={getInterveners}
                                getMorningStarScreener={getMorningStarScreener}
                                getPreMotor={getPreMotor}
                                immBrokerInternalTransferFunds={this.props.immBrokerInternalTransferFunds}
                                immBrokerMyInvestments={this.props.immBrokerMyInvestments}
                                immFlagBasedFeatures={immFlagBasedFeatures}
                                immInvestmentFunds={immInvestmentFunds}
                                onDisclaimerChecked={onDisclaimerChecked}
                                immAccounts={immAccounts}
                                immFunds={immFunds}
                                validateDestinationFundDocuments={validateDestinationFundDocuments}
                                validateEconomicReport={validateEconomicReport}
                            />
                        )
                }
            </WizardStep>
            )
        ]
        if (onlyOriginContribution && hasContributionStep && isTotalTransfer) {
            steps.splice(1, 0, contributionStep);
        }
        const tealiumEventActionByStep = {
            1: 'investmentDetails',
            2: 'investmentDetails2',
            3: 'termsConditions'
        }
        const buttonNextTags = {
            1: 'comprar',
            2: 'comprar'
        }
        const buttonNextTagsWithContribution = {
            1: 'comprar',
            2: 'withPeriodicContribution',
            3: 'comprar'
        }  
        const stepName = tealiumEventActionByStep[visibleStep];
        const buttonNextTag = hasContributionStep ? buttonNextTagsWithContribution[visibleStep] : buttonNextTags[visibleStep];

        return (
            <Wizard
                wizardClass={wizardClass}
                actions={actions}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                immSteps={immSteps}
				tealium={hasContributionStep ? tealiumDataWithContribution[visibleStep - 1] : tealiumDataWithOutContribution[visibleStep - 1]}
                tealiumEvents={catalogue.footerButtons({stepName, productName, isin, buttonNextTag})}
                isTaggingSecondVersion
                children={steps}
            />
        );
    }

    render() {
        const { immBrokerInternalTransferFunds, immFunds, immBrokerMyInvestments, immAccounts, immFlagBasedFeatures, immInvestmentFunds } = this.props;

        const stepSelectFundsCanContinue = immBrokerInternalTransferFunds.get('stepSelectFundsCanContinue');
        let contentBody;

        if (immBrokerInternalTransferFunds.get('submitSuccessful')) {
            contentBody = (
                <BrokerInternalTransferFundsSuccess
                    immBrokerInternalTransferFunds={this.props.immBrokerInternalTransferFunds}
                    immBrokerMyInvestments={this.props.immBrokerMyInvestments}
                    immInvestmentFunds={immInvestmentFunds}
                    immFunds={this.props.immFunds}
                    immAccounts={immAccounts}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                />
            );
        } else if (immBrokerInternalTransferFunds.get('visibleStep') === 1) {
            contentBody = stepSelectFundsCanContinue
                ? this.buildWizard()
                : this.buildSelectFundsStep();
        } else {
            const boxTitle = formatText('brokerInternalTransferFund-title');
            const details = immBrokerInternalTransferFunds.get('isFetching')
                ? <LoadingSection/>
                : (
                    <BrokerInternalTransferFundsDetails
                        immAccounts={immAccounts}
                        immFunds={immFunds}
                        immBrokerInternalTransferFunds={immBrokerInternalTransferFunds}
                        immBrokerMyInvestments={immBrokerMyInvestments}
                    />
                );
            const contentBox = <ContactInfoBox boxTitle={boxTitle} boxBody={details}/>;
            const showCost = immFlagBasedFeatures.get('wealth_funds_transfer_show_costs');
            const contenBoxClassName = showCost ? null : 'col-xs-8';
            contentBody = (
                <div>
                    <div className={contenBoxClassName}>
                        {stepSelectFundsCanContinue ? this.buildWizard(details) : this.buildSelectFundsStep()}
                    </div>
                    { !showCost &&
                        <div className="col-xs-4">
                            {contentBox}
                        </div>
                    }
                </div>
            );
        }

        return (
            <div>
                {this.buildMifid()}
                {contentBody}
            </div>
        )
    }
}

BrokerInternalTransferFunds.propTypes = {

};

BrokerInternalTransferFunds.propTypes = {
    history: PropTypes.object.isRequired,
    immSteps: PropTypes.object,
    immInvestmentFunds: PropTypes.object,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    handleSetAmount: PropTypes.func.isRequired,
    setAproxAmountParticipations: PropTypes.func,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immDestinationFunds: PropTypes.object.isRequired,
    handleChangeType: PropTypes.func.isRequired,
    immBrokerInternalTransferFunds: PropTypes.object.isRequired,
    setOriginFundChange: PropTypes.func.isRequired,
    setDestinationFund: PropTypes.func.isRequired,
    getPreMotor: PropTypes.func.isRequired,
    immFunds: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    getMorningStarScreener: PropTypes.func.isRequired,
    onDisclaimerChecked: PropTypes.func.isRequired,
    onSelectFundsStepNextClick: PropTypes.func.isRequired,
    immBrokerMiFIDProducts: PropTypes.object.isRequired,
    onChangePartialTransferType: PropTypes.func.isRequired,
    onFetchBrokerMiFIDProduct: PropTypes.func.isRequired,
    inputSearchFundSelected: PropTypes.func.isRequired,
    onChangeFundType: PropTypes.func.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    legalYesNoOptionChange: PropTypes.func.isRequired,
    resetLegalInformation: PropTypes.func.isRequired,
    sendEmail: PropTypes.func.isRequired,
    resetEmailState: PropTypes.func.isRequired,
    refreshEmailAddress: PropTypes.func.isRequired,
    getInterveners: PropTypes.func.isRequired,
    setEmptyState: PropTypes.func.isRequired,
    hideModalSelectFunds: PropTypes.func.isRequired,
    validateDestinationFundDocuments: PropTypes.func.isRequired,
    validateEconomicReport: PropTypes.func.isRequired,
    setOriginContributionFundStep: PropTypes.func.isRequired,
    skipContributionStep: PropTypes.func.isRequired,
};

module.exports = withRouter(BrokerInternalTransferFunds);
